import { lazy } from 'react';

// addon-carousel
export const AddonCarousel = lazy(() => import('./addon-carousel/components/AddonCarousel'));
export const PickAndChooseHeader = lazy(() => import('./addon-carousel/components/PickAndChooseHeader'));
export const BundleAndSaveHeader = lazy(() => import('./addon-carousel/components/BundleAndSaveHeader'));

// ads
export const AdBanner = lazy(() => import('./ads/components/AdBanner'));

// banner
export const MlpBanner = lazy(() => import('./banner/components/MlpBanner'));

// Continue-watching-carousel
export const ContinueWatch = lazy(() =>
    import('./Continue-watching-carousel/components/ContinueWatch').then((module) => ({
        default: module.ContinueWatch,
    }))
);

// detail-overlay
export const MovieDetailsOverlayPage = lazy(() => import('./detail-overlay/components/DetailOverlayModal'));

// epg
export const EpgGuideContainer = lazy(() => import('./epg/components/EpgGuideContainer'));

// gamification
export const Banner = lazy(() => import('./gamification/components/Banner'));
export const Reward = lazy(() => import('./gamification/components/Reward'));
export const Redeem = lazy(() => import('./gamification/components/Redeem'));

// header
export const Header = lazy(() => import('./header/components/Header'));

// player
export const GenericBitmovinPlayer = lazy(() => import('./player/components/GenericBitmovinPlayer'));

// ppv
export const PPVDetailModal = lazy(() => import('./ppv/components/PPVDetailsModal'));
export const PPVCarousel = lazy(() => import('./ppv/components/PPVCarousel'));

// promotion
export const MainBanner = lazy(() => import('./promotion/components/MainBanner'));
export const HorizontalBanner = lazy(() => import('./promotion/components/HorizontalBanner'));
export const LongVertical = lazy(() => import('./promotion/components/LongVertical'));
